const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;

export const timeAgo = (isoDate: string, now: Date = new Date()): string => {
  const timestamp = new Date(isoDate).getTime();

  if (Number.isNaN(timestamp)) {
    return "";
  }

  const diffSeconds = Math.floor((now.getTime() - timestamp) / 1000);

  if (diffSeconds < SECONDS_PER_MINUTE) {
    return "just now";
  }

  if (diffSeconds < SECONDS_PER_HOUR) {
    return `${Math.floor(diffSeconds / SECONDS_PER_MINUTE)}m ago`;
  }

  if (diffSeconds < SECONDS_PER_DAY) {
    return `${Math.floor(diffSeconds / SECONDS_PER_HOUR)}h ago`;
  }

  return `${Math.floor(diffSeconds / SECONDS_PER_DAY)}d ago`;
};
